<template>
  <Modal :id="'cpm-add-invoice-modal'" :loading="loading" @cancelled="onCancel">
    <template slot="header"
      >{{$t('add_manual_matches')}}
    </template>

    <template slot="body">
      <div class="form-group">
        <Dropdown
          :options="accountsTV || []"
          :id="'currency'"
          class="m2"
          :selected="accountsTV.find(e => e.value == selectedAccount)"
          :placeholder="$t('accounts')"
          @selectedChange="onDropdownChange"
          box
          :listHeight="250"
        ></Dropdown>
        <TextField
          class="m1"
          :id="'artist'"
          v-bind="textFieldConfig"
          v-model="text02"
          isModel
          :placeholder="$t('identifier')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button s6 v1" @click.stop="addMatchedAccount">
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { releaseService } from "../../services/releases/releases.services";
import { tv, createTV } from "../../../../models/text-value.model";
import { ProductsService } from "../../services/products.service";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      loading: false,
      text02: "",
      Accounts: [],
      selectedAccount: ""
    };
  },
  mounted: async function() {
    const res = await ProductsService.productAccountRelationForm(
      this.external_id
    );
    console.log("RES", res.data.accounts);
    this.Accounts = res.data.accounts;
  },
  computed: {
    accountsTV: function() {
      return createTV(this.Accounts, "account_name", "account_id");
    },
    external_id: function() {
      return this.$route.query.external_id;
    }
  },
  methods: {
    onDateChange: function(name, value) {
      console.log(name, value);
      this.releaseDate = value;
    },
    onTextFieldValueChange: function() {},
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    addMatchedAccount: function() {
      const payload = { account_id: this.selectedAccount, text02: this.text02 };
      this.$emit("create", payload);
    },
    onDropdownChange: function(value) {
      this.selectedAccount = value.value;
      // this[name] = value;
    }

    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cpm-add-invoice-modal {
}
</style>
